<template>
  <zpa-form-item
    :error="error"
    :success="success"
    :validating="validating"
    :required="required"
    :readonly="readonly"
    :disabled="disabled"
    :uuid="uuid"
    :span="span"
    :push="push"
    :label="label"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :itemHeight="itemHeight"
  >
    <ColorPicker
      style="width: 100%;"
      :value="value"
      alpha
      recommend
      @on-change="onInputChange"
    ></ColorPicker>
  </zpa-form-item>
</template>

<script>
import inputMixin from './mixins/input'

export default {
  name: 'zpaColorPicker',

  mixins: [
    inputMixin,
  ],

  props: {
    value: {
      type: String,
      default: '#f0f',
    },
  },
}
</script>
